<template
  ><HiDatatable
    :headers="headers"
    :items="emails"
    @select="selectRow"
    sort-by="date"
    desc
    style="height:100%;"
    unique-id="hive-inboundEmails-list"
  ></HiDatatable>
</template>

<script>
import { collections } from "@/db";
import HiDatatable from "@/components/HiDatatable";
import Formatter from "@/hive/Formatter";

export default {
  name: "InboundEmails",
  components: {
    HiDatatable
  },
  data() {
    return {
      emails: null,
      headers: [
        {
          text: " ",
          value: "parsed",
          renderer: item => {
            const parsed = item.parsed;
            const error = item.error;
            const ignored = item.ignored;

            if (!parsed) return " ";

            if (error) {
              return `<span class="ui-text" style="color:darkred">Parsed</span>`;
            } else if (ignored) {
              return `<span class="ui-text" style="color:darkgrey">Parsed</span>`;
            } else {
              return `<span class="ui-text" style="color:darkolivegreen">Parsed</span>`;
            }
          }
        },
        {
          text: "Date",
          value: "date",
          renderer: item => {
            let text = item.date;
            // console.log(item);

            return `<span class="ui-text">${Formatter.timestamp(
              text,
              true
            )}</span>`;
          }
        },
        {
          text: "From",
          value: "from"
        },
        {
          text: "Subject",
          value: "subject",
          renderer: item => {
            if (item.error)
              return `<div>${item.subject}</div><div class="ui-text" style="color:darkred">Parse Error: ${item.error}</div>`;
            if (item.ignored)
              return `<div>${item.subject}</div><div class="ui-text" style="color:darkgrey">Ignored: ${item.ignored}</div>`;
            return item.subject;
          }
        }
      ]
    };
  },
  firestore: {
    emails: collections.inboundEmails
  },
  methods: {
    selectRow(item) {
      console.log(item);
      this.$emit("select", item);
    }
  }
};
</script>

<style scoped></style>
